export const unitLabel = (unit) => {
  if (!unit?.code) return '';
  return unit.title ? `${unit.code} \u2013 ${unit.title}` : unit.code;
};
